'use strict';

var Backbone = require('backbone'),
  mediator = require('../../js/mediator'),
  config = require('../../js/config'),
  PointyModalView = require('../../js/components/PointyModalView'),
  ProjectEnvisionDesignModalView = require('./ProjectEnvisionDesignModalView'),

  ProjectDetailsEnvisionButton = Backbone.View.extend({

    events: {
      click: 'check'
    },

    initialize: function() {
      this.hasDesign = this.$el.data('hasDesign');
      this.hasDesignText = this.$el.data('hasDesignText');
      this.projectId = this.$el.data('project');

      this.initComponents();

      this.listenTo(this.envisionDesignView, ProjectEnvisionDesignModalView.EVENTS.confirming, this.closePopup);
      this.listenTo(this.envisionDesignView, ProjectEnvisionDesignModalView.EVENTS.cancelled, this.closePopup);

      mediator.on(config.events.designCenter.projectDesignReplaced, this.designAdded, this);
    },

    initComponents: function() {
      this.envisionDesignView = new ProjectEnvisionDesignModalView({
        hasDesign: this.hasDesign,
        projectId: this.projectId,
        pubId: '',
        uri: '',
        reloadOnRename: false
      });
      this.envisionDesignView.render();
      this.pointy = new PointyModalView({
        el: this.el,
        trigger: 'custom',
        contentCloning: false,
        content: this.envisionDesignView.$el
      });
    },

    check: function(e) {
      if (!this.hasDesign) {
        e.preventDefault();
        this.pointy.open();
      }
    },

    openEnvisionOptionsPopup: function(e) {
      if (e) e.preventDefault();
      this.pointy.open();
      mediator.on(config.events.ui.resize, this.closePopup, this);
    },

    closePopup: function() {
      this.pointy.close();
      mediator.off(config.events.ui.resize, this.closePopup);
    },

    designAdded: function(projectId, pubId, data) {

      if (!this.hasDesign && projectId === this.projectId) {
        this.hasDesign = true;
        this.$el.text(this.hasDesignText);
        this.pointy.close();
      }

      this.$el.attr('href', data.uri);
    }


  }, {
    create: function($parent) {
      $parent.find('.js-listing-open-envision').each(function(n, el) {
        new ProjectDetailsEnvisionButton({
          el: el
        });
      });
    }
  });

module.exports = ProjectDetailsEnvisionButton;




// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectDetailsEnvisionButton.js